import { ColumnProps } from './interface';
export default {
  name: 'ATableColumn',
  props: ColumnProps,
  render: function render() {
    return null;
  }
};